import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import OpenApp from "react-open-app";
import utcDateTime from '../../utcdatetime'
//import your fontawesome icons here
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faChevronRight } from '@fortawesome/free-solid-svg-icons'

//import your components here
import Image from "../../components/image"
import Styles from "./cards.module.scss"

var CryptoJS = require("crypto-js");

const isBrowser = () => typeof window !== "undefined"
const isMobile = isBrowser() ? (window.innerWidth < 980 ? true : false) :  false

function Card(props) {

  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (isBrowser()) {
      setWidth(window.innerWidth);
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  let color_array = ['#3f677a','#576e9a','#3e6b87','#3182a0']
  let strip_color_array = ['#29424c', '#435679', '#315267', '#21596d']
  let start_date ;

  function showCardImage(members) {
    if (members && members.length > 0) {
      return(
        members.map ( (node,index) => (
          <div key={index} className={` ${Styles.group_card_img} ${index > 0 ? Styles.margin_left_negative : ``} d-flex float-left`} style={{background: '#efaf70',borderRadius: '25px'}}>
            <h6 className={`text-uppercase text-white m-auto`} style={{fontSize: `small`}} >{node.first_name ? node.first_name.charAt(0) : ''}{node.last_name ? node.last_name.charAt(0) : ''}</h6>
          </div>
        ))
      )
    }
  }
  const getCourseDuration = (start_time, end_time) => {
    let training_start_time = utcDateTime.utcDateTime(start_time)
    let training_end_time = utcDateTime.utcDateTime(end_time)
    let time_difference = training_end_time.getTime() - training_start_time.getTime()
    let time_difference_in_mins = Math.floor(time_difference / (1000 * 60))
    let hours = Math.floor(time_difference_in_mins / 60)
    let minutes = time_difference_in_mins - (hours * 60)
    let time = '', hrs_in_string = '', min_in_string = ''
    hrs_in_string = hours < 10 ? hours === 1 ? '01hr' : `0${hours}hrs` : `${hours}hrs`
    min_in_string = minutes < 10 ? minutes === 1 ? '01min' : `0${minutes}mins` : `${minutes}mins`
    time = minutes === 0 ? hrs_in_string : `${hrs_in_string} ${min_in_string}`
    return time
  }

  if (props.training !== undefined && props.training.length !== 0  && props.training.start_date !== null) {
    start_date = `${utcDateTime.utcDateTime(props.training.start_date, 'date')} ${utcDateTime.utcDateTime(props.training.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.training.start_date, 'year')}`
  }else{
    start_date = 'will be scheduled soon'
  }
  if (props.type === 'classroom') {
    let classroom_training_start_date
    let slug = "";
    if (props.classroomCourses) {
      for (var i = 0; i <= props.classroomCourses.length - 1; i++) {
        if (props.classroomCourses[i].long_title === props.name) {
          if (props.classroomCourses[i].seo_slug !== "") {
            slug = props.classroomCourses[i].seo_slug
          }else {
            slug = `courses/${props.classroomCourses[i].name}`
          }
          if (props.classroomCourses[i].trainings !== undefined && props.classroomCourses[i].trainings.length !== 0  && props.classroomCourses[i].trainings.start_date !== null) {
            classroom_training_start_date = `${utcDateTime.utcDateTime(props.classroomCourses[i].trainings.start_date, 'date')} ${utcDateTime.utcDateTime(props.classroomCourses[i].trainings.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.classroomCourses[i].trainings.start_date, 'year')}`
          } else {
            classroom_training_start_date = "will be scheduled soon"
          }
        }
      }
    }
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
          <Link className={`no_text_decoration`} to={`/${slug}`}>
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Next Batch : {props.classroomCourses ? classroom_training_start_date === undefined ? <span style={{ fontSize: '13px' }} ><Spinner animation="border" size="sm" />  Loading...</span>  : classroom_training_start_date : start_date}</h6>
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </Link>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240}`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`/${slug}`}>
            <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`classroom-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <div className="text-white" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
                <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>Upcoming Training</h6>
                <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '16px'}}>{props.classroomCourses ? classroom_training_start_date === undefined ? <div style={{ fontSize: '16px' }} ><Spinner animation="border" size="sm" className={`mr-1`} />  Loading...</div> : classroom_training_start_date : start_date}</h6>
                {/*<h6 className="float-right" style={{ margin: `0px`,fontWeight: 'bold',top: '-28px',position: 'relative', right: `10px`}}> > </h6>*/}
              </div>
              <h5 className={`${Styles.card_button}`}>Register</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'online') {
    let online_training_start_date;
    let slug = "";
    let crash_hide = ''
    if (props.onlineCourses) {
      let course = props.onlineCourses.find(course => course.long_title === props.name)
      if (course) {
        if (course.trainings !== undefined && course.trainings.length !== 0  && course.trainings.start_date !== null) {
          online_training_start_date = `${utcDateTime.utcDateTime(course.trainings.start_date, 'date')} ${utcDateTime.utcDateTime(course.trainings.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(course.trainings.start_date, 'year')}`
        } else {
          online_training_start_date = "will be scheduled soon"
          if (props.special_class === true) {
            crash_hide = ''
          }else{
            crash_hide = 'hidden'
          }
        }
      }
    }
    if (props.special_class === true) {
      if (props.slug) {
        slug = `/online/${props.slug}`
      } else {
        slug = `/online/${props.course_name}`
      }
    }else{
      slug = `/onlinecourses/${props.course_name}`
    }
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} className='' style={{padding:'7px 7px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Next Batch : {props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}</h6>
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </Link>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240} ${crash_hide}`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`online-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <div className="text-white" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
                <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>Upcoming Training</h6>
                <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '16px'}}>{props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}</h6>
                {/*<h6 className="float-right" style={{ margin: `0px`,fontWeight: 'bold',top: '-28px',position: 'relative', right: `10px`}}> > </h6>*/}
              </div>
              <h5 className={`${Styles.card_button}`}>Register</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'onlinecrash') {
    let online_training_start_date, crash_hide = '';
    let slug = `/onlinecourses/${props.slug}`;
    if (props.onlineCourses !== undefined && props.onlineCourses.length !== 0  && props.onlineCourses.start_date !== null) {
      online_training_start_date = `${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'date')} ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'year')}`
    } else {
      online_training_start_date = "will be scheduled soon"
      crash_hide = 'hidden'
    }
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Next Batch : {props.onlineCourses ? online_training_start_date === undefined ? 'Loading...'  : online_training_start_date : start_date}</h6>
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </Link>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240} ${crash_hide}`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`online-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <div className="text-white" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
                <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>Upcoming Training</h6>
                <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '16px'}}>{props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}</h6>
                {/*<h6 className="float-right" style={{ margin: `0px`,fontWeight: 'bold',top: '-28px',position: 'relative', right: `10px`}}> > </h6>*/}
              </div>
              <h5 className={`${Styles.card_button}`}>Register</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'sales_online_crash') {
    let online_training_start_date;
    let slug = `/onlinecourses/${props.slug}`;
    if (props.onlineCourses !== undefined && props.onlineCourses.length !== 0  && props.onlineCourses.start_date !== null) {
      online_training_start_date = `${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'date')} ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'year')}`
    }
    if (width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" key={props.index.toString()+props.type} className={`float-left mb-2`}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)'}}>
              <div className="float-left px-2" style={{minWidth: '80px', maxWidth: '80px'}}>
                <picture>
                  <LazyLoadImage src={props.avatar} alt={`${props.name.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px'}}/>
                </picture>
              </div>
              <div className="float-left pr-2 d-flex align-items-center w-100">
                <div className="float-left w-100">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.name}</h3>
                  <h3 className="mb-1 font-weight-bold w-100" style={{color: 'rgb(101, 102, 103)', fontSize: '12px'}}>{`Next Batch : ${props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}`}</h3>
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(49, 159, 203)'}}/>
              </div>
            </Col>
          </Link>
        </Col>
      )
    } else {
      return(
        <Col key={props.index.toString()+props.type} className={`float-left px-0 mr-4 mb-3`} style={{minWidth: '230px', maxWidth: '230px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`float-left text-white`} style={{ borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div className="p-2" style={{height: `120px`}}>
                <div style={{width: `50px`, height: `50px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" width={'100%'} style={{objectFit: `contain`}} />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`online-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', fontSize: '15px'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', fontSize: '15px'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <div className="text-white float-left w-100" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
                <p className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: 'small'}}>Upcoming Training</p>
                <p style={{ paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: 'small'}}>{props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}</p>
              </div>
              <div className="float-left w-100 my-1">
                <h5 className={`${Styles.card_button} font-weight-normal`} style={{fontSize: '14px'}}>Register</h5>
              </div>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'sales_online_crash_carousel') {
    let online_training_start_date
    let slug = `/onlinecourses/${props.slug}`;
    if (props.onlineCourses !== undefined && props.onlineCourses.length !== 0  && props.onlineCourses.start_date !== null) {
      online_training_start_date = `${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'date')} ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'year')}`
    }
    return(
      <div key={props.index.toString()+props.type} className={`float-left px-2`} style={{maxWidth: '200px', minWidth: '200px'}}>
        <Link className={`no_text_decoration`} to={`${slug}`}>
          <div className={`text-white float-left`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
            <div className="p-2" style={{height: `100px`}}>
              <div style={{width: `40px`, height: `40px`}} >
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" width={'100%'} style={{objectFit: `contain`}} />
              </div>
              {props.name && props.name.length > 35 ?
                <OverlayTrigger placement={'top'} overlay={<Tooltip className="event-tooltip" id={`online-${props.name}`}>{props.name ? props.name : ""}</Tooltip>}>
                  <h6 className={`ellipsis_2_effect`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', fontSize: '14px' }} >{props.name ? props.name : ""}</h6>
                </OverlayTrigger>
                :
                <h6 className={`ellipsis_2_effect`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', fontSize: '14px' }} >{props.name ? props.name : ""}</h6>
              }
            </div>
            <div className="text-white float-left w-100" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
              <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>Upcoming Training</h6>
              <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '12px'}}>{props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : online_training_start_date : start_date}</h6>
            </div>
            <div className="float-left w-100 my-1">
              <h5 className={`${Styles.card_button} font-weight-normal`} style={{fontSize: '14px'}}>Register</h5>
            </div>
          </div>
        </Link>
      </div>
    )
  }else if (props.type === 'onlinepastcrash') {
    let online_training_start_date, crash_hide = '';
    let slug = `/onlinecrashcourses/pastcrash/${props.slug}`;
    if (props.onlineCourses !== undefined && props.onlineCourses.length !== 0  && props.onlineCourses.start_date !== null) {
      online_training_start_date = `${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'date')} ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'year')}`
    } else {
      online_training_start_date = "will be scheduled soon"
      crash_hide = 'hidden'
    }
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} style={{padding:'10px 7px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Watch Recording</h6>
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </Link>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240} ${crash_hide}`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`text-white`} style={{ color: `white`, maxHeight: '190px', minHeight: '190px', height: '190px', borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`online-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <h5 className={`mb-3 ${Styles.card_button}`}>Watch Recording</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'upcoming_past_crash') {
    let online_training_start_date, crash_hide = '', slug = '';
    if (props.upcoming_past === 'upcoming') {
      slug = `/onlinecourses/${props.slug}`;
    } else {
      slug = `/onlinecrashcourses/pastcrash/${props.slug}`;
    }
    if (props.onlineCourses !== undefined && props.onlineCourses.length !== 0  && props.onlineCourses.start_date !== null) {
      online_training_start_date = `${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'date')} ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'short_month_name')}, ${utcDateTime.utcDateTime(props.onlineCourses.start_date, 'year')}`
    } else {
      online_training_start_date = "will be scheduled soon"
      crash_hide = 'hidden'
    }
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                {props.upcoming_past === 'upcoming' ? 
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Next Batch : {props.onlineCourses ? online_training_start_date === undefined ? 'Loading...'  : online_training_start_date : start_date}</h6> :
                <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >Watch Recording</h6>}
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </Link>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240} ${crash_hide} h-100`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.name && props.name.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`online-${props.name}`} >
                        {props.name ? props.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                }
              </div>
              <div className="text-white" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)]}}>
                <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>{props.upcoming_past === 'upcoming' ? `Upcoming Training` : 'Course Duration'}</h6>
                <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '16px'}}>{props.onlineCourses ? online_training_start_date === undefined ? 'Loading...' : props.upcoming_past === 'upcoming' ? online_training_start_date : getCourseDuration(props.onlineCourses.start_date, props.onlineCourses.end_date) : start_date}</h6>
                {/*<h6 className="float-right" style={{ margin: `0px`,fontWeight: 'bold',top: '-28px',position: 'relative', right: `10px`}}> > </h6>*/}
              </div>
              <h5 className={`${Styles.card_button}`}>{props.upcoming_past === 'upcoming' ? 'Register' : 'Watch Recording'}</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'related') {
    let slug = ''
    let course = props.course
    if (course.e_learning === true) {
      slug= `/eLearning/${props.name}`;
    }else if (course.online === true) {
      if (course.special_class === true && course.seo_slug !== '') {
        slug= `/online/${course.seo_slug}`;
      }else{
        slug= `/online/${props.name}`;
      }
      if (course.special_class === false) {
        slug= `/onlinecourses/${props.slug}`;
      }
    }else if (course.classroom === true) {
      if (course.seo_slug !== '') {
        slug= `${course.seo_slug}`;
      }else{
        slug= `/courses/${props.name}`;
      }
    }
    return(
      <div className={`text-white float-left mt-2`} style={{ width: `200px`, maxWidth: `200px`, minWidth: `200px`, borderRadius: '15px', backgroundColor: props.data_type === "past" ? '#6c6c6c' : color_array[(props.index)%(color_array.length)] }}>
        <div className={`px-2 pt-2 mx-1`} style={{width: `60px`, height: `65px`}}>
          <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
            style={{ margin: '0px', objectFit: `contain`}} />
        </div>
        <div className={`px-2 pt-2`} style={{ height: `50px` }}>
          {props.name && props.name.length > 40 ?
              <OverlayTrigger
                placement={'top'}
                overlay={
                  <Tooltip className="training-tooltip" id={`training-${props.id}`} >
                    {props.name ? props.name : ""}
                  </Tooltip>
                }
              >
                <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
              </OverlayTrigger>
              :
              <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
            }
        </div>
        <div className={`py-2 text-center font-weight-bold`} style={{ borderTop: `1px solid white`, fontSize: '13px' }}>
          <Link to={`${slug}`} className={`text-white`}>
            <div>
              Register
              <div className={`${Styles.arrow_right} ml-1`}></div>
            </div>
          </Link>
        </div>
      </div>
    )
  }else if (props.type === 'elearn'){
    let slug = "";
    if (props.slug) {
      slug = `/eLearning/${props.slug}`
    } else {
      slug = `/eLearning/${props.name}`
    }
    if (isMobile || width <= 980) {
      if (props.sub_type === 'client_search') {
        return(
          <Col xs="12" sm="6" md="6" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
            <Link className={`no_text_decoration`} to={`/${slug}`}>
              <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)', minHeight: '100px', maxHeight: '100px'}}>
                <div className="float-left px-2" style={{minWidth: '80px', maxWidth: '80px'}}>
                  <picture>
                    <LazyLoadImage src={props.avatar} alt={`${props.name.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px'}}/>
                  </picture>
                </div>
                <div className="float-left w-100 pr-2">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.name}</h3>
                  <h3 className="mb-1 font-weight-bold w-100 ellipsis_2_effect" style={{color: 'rgb(101, 102, 103)', fontSize: '12px'}}>{props.tag_line}</h3>
                </div>
              </Col>
            </Link>
          </Col>
        )
      } else {
        return(
          <Col xs="12" sm="6" md="6" lg="3" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
            <Link className={`no_text_decoration`} to={`${slug}`}>
              <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
                <div style={{width:'15%',minWidth:'60px'}} >
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                    style={{ margin: '0px', objectFit: `contain`}}
                  />
                </div>
                <div style={{width:'80%'}}  className={`pl-2`} >
                  <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                  <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >{props.tag_line}</h6>
                </div>
                <div style={{width:'5%'}}  className={`pl-2`} >
                  <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
                </div>
              </div>
            </Link>
          </Col>
        )
      }
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_20} text-black`} style={{padding: '0px', margin: '5px 35px 25px 5px', borderRadius: '25px',backgroundColor: 'white',boxShadow: '0px 0px 9px 0px grey', paddingLeft: '0px'}}>
          <Link className="text-black no_text_decoration" to={`${slug}`}>
            <div className="" style={{ color: `black`,height: '185px',padding: '12px',borderBottom: '1px solid black' }}>
              <div style={{width: `60px`, height: `60px`}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <h6 className={`ellipsis_2_effect`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}}>{props.name}</h6>
              <h6 className={`text-left ellipsis_2_effect`} style={{ paddingTop: `15px`, margin: `0px`,fontWeight: '400',fontSize: '14px', WebkitBoxOrient: 'vertical'}}>{props.tag_line}</h6>
            </div>
            <div className={`d-flex align-items-center justify-center ${Styles.elearn_card}`} style={{marginTop: '0px' }}>
              <h6 className="text-center" style={{marginTop: '6px',fontWeight: '500'}} >Register</h6><div className="sprite_image_2 down_black_arrow rotate-right ml-2 my-auto"></div>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'sales_elearn'){
    let slug = "";
    if (props.slug) {
      slug = `/eLearning/${props.slug}`
    } else {
      slug = `/eLearning/${props.name}`
    }
    if (width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" key={props.index.toString()+props.type} className={`float-left mb-2`}>
          <Link className={`no_text_decoration`} to={`${slug}`}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)'}}>
              <div className="float-left px-2" style={{minWidth: '80px', maxWidth: '80px'}}>
                <picture>
                  <LazyLoadImage src={props.avatar} alt={`${props.name.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px'}}/>
                </picture>
              </div>
              <div className="float-left pr-2 d-flex align-items-center w-100">
                <div className="float-left w-100">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.name}</h3>
                  <h3 className="mb-1 font-weight-bold w-100 ellipsis_2_effect" style={{color: 'rgb(101, 102, 103)', fontSize: '12px'}}>{props.tag_line}</h3>
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(49, 159, 203)'}}/>
              </div>
            </Col>
          </Link>
        </Col>
      )
    } else {
      return(
        <Col key={`${props.index.toString()}-${props.type}`} className={`float-left px-0 mr-4 mb-3`} style={{minWidth: '230px', maxWidth: '230px', boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
          <Link className="no_text_decoration" to={`${slug}`} style={{color: 'rgb(95, 93, 93)'}}>
            <div className="p-2" style={{height: '165px', borderBottom: `1px solid rgb(95, 93, 93)`}}>
              <div style={{width: `50px`, height: `50px`}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" width={'100%'} style={{objectFit: `contain`}} />
              </div>
              <h6 className={`ellipsis_2_effect`} style={{paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', fontSize: '15px'}}>{props.name}</h6>
              <h6 className={`text-left ellipsis_2_effect`} style={{paddingTop: `15px`, margin: `0px`,fontWeight: '400',fontSize: 'small', WebkitBoxOrient: 'vertical'}}>{props.tag_line}</h6>
            </div>
            <div className={`d-flex align-items-center justify-center ${Styles.elearn_card}`} style={{marginTop: '0px' }}>
              <h5 className={`text-center font-weight-normal mb-0 d-flex align-items-center py-2`} style={{fontSize: '15px', color: 'rgb(95, 93, 93)'}}>Register<div className="sprite_image_2 down_black_arrow rotate-right ml-1 my-auto"></div></h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if (props.type === 'trainings'){
    return(
      <Col key={props.index.toString()+props.type} sm="3" className="float-left">
        <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[props.index] }}>
            <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
              style={{ margin: '0px', objectFit: `contain`}}
            />
          <h6 style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold'}}>{props.name}</h6>
        </div>
        <div style={{ color: `white`, marginTop: '0px', borderTop: '1px solid' }}>
          <h6 style={{ textAlign: 'center', marginTop: '5px', fontWeight: '500' }} >Register </h6>
        </div>
      </Col>
    )
  }else if (props.type === 'quizzes'){
    if (isMobile || width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" key={props.index.toString()+props.type} style={{padding:'7px 7px'}}>
          <div className={`text-white d-flex`} style={{padding: `11px 11px 3px 11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
            <div style={{width:'15%',minWidth:'60px'}} >
              <Image src={props.avatar} imgStyle={{ objectFit: `contain` }} style={{ width: `60px`, height: `60px` }} type={`fixed`} />
            </div>
            <div style={{width:'85%'}}  className={`pl-2`} >
              <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.fullname}</h6>
              <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}}>{props.questions} Questions &nbsp;&nbsp; 2 Mockups</h6>
              <div  className={`d-flex pt-2`} style={{flexWrap:'wrap'}} >
                <div onClick={()=>props.onClickBuy()} className={`d-flex mr-3 mb-2 pointer ${Styles.mobile_buy_try_btn}`}><h6 className="font-14 mb-0 py-1" style={{color: `#1e8cbc`}} >Buy Now <FontAwesomeIcon icon={faChevronRight} /> </h6></div>
                <div onClick={()=>props.onClickTry()} className={`d-flex mb-2 pointer ${Styles.mobile_buy_try_btn}`}><h6 className="font-14 mb-0 py-1" style={{color: `#1e8cbc`}} >Try Demo <FontAwesomeIcon icon={faChevronRight} /> </h6></div>
              </div>
            </div>
          </div>
        </Col>
      )
    }else{
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_20_height}`}>
          <div style={{ borderRadius: '25px', backgroundColor: '#3f677a',height: '300px'}}>
            <div className="" style={{ color: `black`, padding: '12px',height: '200px' }}>
              <Image src={props.avatar} imgStyle={{ objectFit: `contain` }} style={{ width: `60px`, height: `60px` }} type={`fixed`} />
              <h6 className="text-white" style={{ paddingTop: `5px`, margin: `0px`, fontWeight: 'bold' }}>{props.fullname}</h6>
              <h6 className="text-white" style={{ paddingTop: `5px`, margin: `0px`, fontWeight: '500',fontSize: '13px' }}>{props.questions} Questions</h6>
              <h6 className="text-white text-left" style={{ paddingTop: `15px`, margin: `0px`, fontWeight: '400', fontSize: '13px' }}>{props.subheading}</h6>
            </div>
            <div onClick={()=>props.onClickBuy()} className={`d-flex align-items-center pointer justify-center`} style={{padding: '8px 0px',backgroundColor: '#2c4652',marginTop: '15px'  }}>
              <div className={`d-flex ml-0 my-auto  ${Styles.quiz_static_card}`}><h6 className="mb-0" style={{fontWeight: '500'}} >Buy Now </h6><div className="sprite_image_2 down_white_arrow rotate-right ml-2 my-auto"></div></div>
            </div>
            <div onClick={()=>props.onClickTry()} className={`d-flex align-items-center pointer justify-center`} style={{padding: '8px 0px' }}>
              <div className={`d-flex ml-0 my-auto ${Styles.quiz_static_card}`}><h6 style={{fontWeight: '500',margin: '0px'}} >Try Demo </h6><div className="sprite_image_2 down_white_arrow rotate-right ml-2 my-auto"></div></div>
            </div>
          </div>
        </Col>
      )
    }
  }else if (props.type === 'open_quizzes'){
    let image_url = 'https://lp-admin-static.s3.amazonaws.com/' + props.avatar
    return(
      <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_20_height}`}>
        <div style={{ borderRadius: '25px', backgroundColor: '#3f677a',height: '260px'}}>
          <div className="" style={{ color: `black`, padding: '12px',height: '200px' }}>
            <LazyLoadImage src={image_url} alt={props.main_name} effect="blur" height={'60px'} width={'60px'}
              style={{ margin: '0px', objectFit: `contain`}}
            />
            <h6 className="text-white" style={{ paddingTop: `5px`, margin: `0px`, fontWeight: 'bold' }}>{props.fullname}</h6>
            <h6 className="text-white" style={{ paddingTop: `5px`, margin: `0px`, fontWeight: '500',fontSize: '13px' }}>{props.questions} Questions | {props.attempts} attempts</h6>
            <h6 className="text-white text-center" style={{ paddingTop: `15px`, margin: `0px`, fontWeight: '400', fontSize: '13px' }}>{props.subheading}</h6>
          </div>
          <div className="text-center mt-3">
            <Button onClick={()=>props.handleOtpModal()} style={{borderRadius:'25px',backgroundColor:'#2c4652',border:'none',fontSize:'.9rem',padding:'1px 22px',}} >Take Quiz</Button>
          </div>
          {/*<div className="pointer" style={{padding: '8px 0px',backgroundColor: '#2c4652',marginTop: '15px' }}>
            <h6 className="text-white text-center" style={{fontWeight: '500',margin: '0px'}} >Take Quiz<FontAwesomeIcon style={{margin: '0px 0px 0px 0px',paddingTop: '2px'}} icon={faAngleRight} size="1x" /> </h6>
          </div>*/}
        </div>
      </Col>
    )
  }else if (props.type === 'event' && props.event_data){
    let event_data = props.event_data
    let day,month,year,event_date
    var event_type = ["Webinar","Meetup","Coaching","Conference"]
    var event_bg = ['#4444B7', '#722970', '#236361', '#8C2525']
    var colors = ['#F3EFFD', '#EFFDF1', '#E7FCFD', '#FDE7FA', '#E7EFFD', '#FDE7E7', '#FDF5E7', '#E8FCFF', '#FFF5C1' ]

    event_date = event_data.start_date ? `${utcDateTime.utcDateTime(event_data.start_date, 'date')} ${utcDateTime.utcDateTime(event_data.start_date, 'month_name')}, ${utcDateTime.utcDateTime(event_data.start_date, 'year')}` : 'will be scheduled soon'
    let div_t =
    <div className={`float-left mb-3 mr-4 pointer`} style={{ width: `250px`, boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px' }} >
      <div className={`float-left`} >
        <div style={{ position: `relative`, borderBottom: `1px solid #ebebeb` }}>
          {event_data.background_avatar === undefined || event_data.background_avatar === null ?
            <Image src={'event_bg.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `250px`, height: `180px`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px`, backgroundColor: event_bg[event_data.event_type] }} type={`fluid`} />
            :
            <LazyLoadImage src={event_data.background_avatar} alt={event_data.title} effect="blur" height={'180px'} width={'250px'}
              style={{ margin: '0px', objectFit: `cover`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px` }}
            />
          }
          <h6 className={`mr-3 py-1 px-2 font-weight-bold d-flex`} style={{ marginTop: `15px`, position: `absolute`, top: `0`, right: `0`, backgroundColor: `#f5f6f8`, borderRadius: `15px`, boxShadow: 'rgb(216, 214, 214) 0px 0px 4px 0px', fontSize: `small` }}>
            <div className={`d-flex`}><span className={`${event_type[event_data.event_type].toLowerCase()+'_icon'} mr-2 my-auto`}></span></div>{event_type[event_data.event_type]}
          </h6>
          <h3 className={`font-weight-bold my-0 mx-auto text-center text-white ${Styles.drop_shadow_icon} ${event_data.background_avatar === undefined || event_data.background_avatar === null ? '' : 'd-none'} `} style={{ position: `absolute`, top: `70px`, bottom: `70px`, left: `0`, right: `0`, fontSize: `34px`, fontFamily: `sans-serif` }}>
            {event_type[event_data.event_type]}
          </h3>
          <div className={`${event_data.license_type !== 'Basic' ? '' : 'd-none'}`} style={{ position: `absolute`, top: `0`, left: `0`}}>
            <Image src={event_data.license_type.toLowerCase()+'_pricing.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `80px`, height: `80px`, zIndex: 1 }} type={`fluid`} />
          </div>
        </div>
        <Col lg="12" md="12" sm="12" xs="12" className={`float-left pt-2 pb-3`} >
          <span className={`px-2 py-1 ${event_data.meetup === undefined ? 'bg-transparent' : ''}`} style={{ color: '#6f6f6f', backgroundColor: colors[props.index % 9], borderRadius: '15px', fontSize: `11px` }}>{event_data.meetup && event_data.meetup.length > 29 ? event_data.meetup.slice(0, 25)+'...' : event_data.meetup}</span>
          <div className={`my-2 d-flex tooltip-div-event`} style={{ height: `42px` }}>
          {event_data.title && event_data.title.length > 50 ?
            <OverlayTrigger
              placement={'top'}
              overlay={
                <Tooltip className="event-tooltip" id={`event-${event_data.id}`} >
                  {event_data.title ? event_data.title : ""}
                </Tooltip>
              }
            >
              <h6 className={`ellipsis_2_effect bold mx-0 my-auto`} style={{fontSize: `15px`}} >{event_data.title ? event_data.title : ""}</h6>
            </OverlayTrigger>
            :
            <h6 className={`ellipsis_2_effect bold mx-0 my-auto`} style={{fontSize: `15px`}} >{event_data.title ? event_data.title : ""}</h6>
          }
          </div>
            <p className={`mb-1 d-flex`} style={{ fontSize: `small`, color: `#5c5858` }} ><span className={`calendar_icon my-auto mr-1`}></span> : {event_date}</p>
            <p className={`m-0 d-flex`} style={{ fontSize: `small`, color: `#5c5858` }} ><span className={`${event_data.city ? 'venue_icon' : 'webinar_icon' } my-auto mr-1`}></span> : {event_data.city ? event_data.city : 'Online'}</p>
        </Col>
      </div>
    </div>
    if (width != 0) {
      if (isMobile || width <= 980) {
        let mobile_div_t =
          <Col xs="12" sm="12" md="12" className={`pointer d-flex py-2`} style={{ width: `${width}`, boxShadow: 'rgb(216, 214, 214) 0px 6px 8px 1px',alignItems:'center',height:'100%', paddinng: '1px 10px' }} >
            <Col md="5" sm="5" xs="4" className="px-0 d-flex" style={{width:'125px'}}>
              {event_data.background_avatar === undefined || event_data.background_avatar === null ?
                <Image src={'event_bg.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `100%`, minHeight: '90px', borderRadius: `10px`, backgroundColor: event_bg[event_data.event_type] }} type={`fluid`} />
                :
                <LazyLoadImage src={event_data.background_avatar} alt={event_data.title} effect="blur"
                  style={{ margin: '0px', objectFit: `cover`, borderRadius: `10px`, minHeight: '90px', width: '100%' }}
                />
              }
              <h6 className={`mr-2 font-weight-bold d-flex`} style={{ padding:'2px 4px',marginTop: `15px`, position: `absolute`, top: `0`, right: `0`, backgroundColor: `#f5f6f8`, borderRadius: `15px`, boxShadow: 'rgb(216, 214, 214) 0px 0px 4px 0px', fontSize: `12px` }}>{event_type[event_data.event_type]}</h6>
              <div className={`${event_data.license_type !== 'Basic' ? '' : 'd-none'}`} style={{ position: `absolute`, top: `0`, left: `0`}}>
                <Image src={event_data.license_type.toLowerCase()+'_pricing.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `60px`, height: `60px`, zIndex: 1 }} type={`fluid`} />
              </div>
            </Col>
            <Col md="7" sm="7" xs="8" className={`pl-2 pr-0 float-left d-flex align-items-center`} >
              <div className="float-left w-100">
                <div className={`my-1 d-flex tooltip-div-event`} style={{}}>
                  <h6 className={`ellipsis_2_effect bold mx-0 my-auto`} style={{fontSize: `14px`, color: `#3b3b3b`}} >{event_data.title ? event_data.title : ""}</h6>
                </div>
                <p className={`mb-1 d-flex`} style={{ fontSize: `12px`, color: `#5c5858` }} ><span className={`calendar_icon my-auto mr-1`}></span> : {event_date}</p>
                <p className={`m-0 d-flex`} style={{ fontSize: `12px`, color: `#5c5858` }} ><span className={`${event_data.city ? 'venue_icon' : 'webinar_icon' } my-auto mr-1`}></span> : {event_data.city ? event_data.city : 'Online'}</p>
              </div>
              <FontAwesomeIcon icon={faAngleRight} size="lg" style={{color: '#3b3b3b', fontSize: `14px`}} />
            </Col>
          </Col>
        if ((event_data.event_type === '3' && event_data.slug.indexOf("conference_slug") > -1) || event_data.slug.indexOf("open_by_slug") > -1) {
          return(
            <a className={`text-black w-100`} href={event_data.webinar_link} target="_blank" rel="noopener noreferrer">
              {mobile_div_t}
            </a>
          )
        }else {
          return(
            <Link className={`text-black w-100`} to={`/events/${event_data.slug}`}>
              {mobile_div_t}
            </Link>
          )
        }
      }else{
        if ((event_data.event_type === '3' && event_data.slug.indexOf("conference_slug") > -1) || event_data.slug.indexOf("open_by_slug") > -1) {
          return(
            <a className={`text-black`} href={event_data.webinar_link} target="_blank" rel="noopener noreferrer">
              {div_t}
            </a>
          )
        }else {
          return(
            <Link className={`text-black`} to={`/events/${event_data.slug}`}>
              {div_t}
            </Link>
          )
        }
      }
    }
    else{
      return <p>Loading...</p>
    }
  }else if (props.type === 'group' || props.type === 'horizontal_group'){
    let groups_data = props.groups_data
    if (groups_data) {
      if (width != 0 && width <= 980) {
        return(
          <Link className={`text-black`} to={`/groups/${groups_data.slug}`}>
            <Col xs="12" sm="12" md="12" lg="12" className={`${props.type === 'group' ? `py-2  p-0 mx-auto` : `py-2`} pointer`} style={{ boxShadow: '#77b8d5 0px 0px 3px 0px', borderRadius: '15px', position: `relative`, minHeight: props.type === 'group' ? `auto`: `100%` }}>
              <div style={props.type === 'group' ? {} : {} }>
                { groups_data.name && groups_data.name.length > (props.type === 'group' ? 40 : 45)?
                  <OverlayTrigger
                    placement={props.type === 'group' ? 'left' : 'top'}
                    overlay={
                      <Tooltip className={`${ props.type === 'group' ? `group-tooltip2` : `group-tooltip`}`} id={`group-name-${groups_data.id}`} >
                        {groups_data.name ? groups_data.name : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`pt-2 mb-2 px-3 ellipsis_2_effect ${props.type === 'group' ? `m-0` : `mx-0 my-auto`} `} style={{ WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `15px` : `inherit`, color: '#5dacce' }}>{groups_data.name}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`py-2 px-3 ellipsis_2_effect ${props.type === 'group' ? `m-0` : `mx-0 my-auto`} `} style={{ WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `15px` : `inherit`, color: '#5dacce' }}>{groups_data.name}</h6>
                }
              </div>
              <div style={ props.type === 'group' ? {} : {width: `100%`} }>
                {groups_data.card_summary && groups_data.card_summary.length > (props.type === 'group' ? 51 : 57) ?
                  <OverlayTrigger
                    placement={props.type === 'group' ? 'left' : 'top'}
                    overlay={
                      <Tooltip className={`${ props.type === 'group' ? `group-tooltip2` : `group-tooltip`}`} id={`group-${groups_data.id}`} >
                        {groups_data.card_summary ? groups_data.card_summary : ""}
                      </Tooltip>
                    }
                  >
                    <p className={`px-3 m-0 bg-transparent ellipsis_2_effect`} style={{WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `13px` : `15px`, lineHeight: `normal`, color: '#848484'}}>{ groups_data.card_summary ? groups_data.card_summary : ''} </p>
                  </OverlayTrigger>
                  :
                  <p className={`px-3 m-0 bg-transparent ellipsis_2_effect`} style={{WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `13px` : `15px`, lineHeight: `normal`, color: '#848484'}}>{ groups_data.card_summary ? groups_data.card_summary : ''} </p>
                }
                <div className={`my-2 mx-3 text-center d-flex`}>
                  {showCardImage(groups_data.members)}
                  <p className={`ml-2 my-0 align-self-center ${groups_data.count === 0 ? `d-none` : ``}`} style={{fontSize: props.type === 'group' ? `13px` : `18px`, color: '#535353'}}>{groups_data.count ? groups_data.count : ''} {groups_data.count === 1 ? `Member` : `Members`}</p>
                </div>
              </div>
            </Col>
          </Link>
        )
      }else{
        return(
          <Link className={`text-black`} to={`/groups/${groups_data.slug}`}>
            <div className={`${props.type === 'group' ? `mb-4 p-0 mx-auto` : `mx-3`} pointer`} style={{ boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px', minWidth: props.type === 'group' ? `210px` : `286px`, maxWidth: props.type === 'group' ? `210px` : `286px`, width: props.type === 'group' ? `210px` : `286px`, position: `relative`, minHeight: props.type === 'group' ? `auto`: `170px` }}>
                <div style={props.type === 'group' ? {} : {height: `50px`, display: `flex`} }>
                  { groups_data.name && groups_data.name.length > (props.type === 'group' ? 40 : 45)?
                    <OverlayTrigger
                      placement={props.type === 'group' ? 'left' : 'top'}
                      overlay={
                        <Tooltip className={`${ props.type === 'group' ? `group-tooltip2` : `group-tooltip`}`} id={`group-name-${groups_data.id}`} >
                          {groups_data.name ? groups_data.name : ""}
                        </Tooltip>
                      }
                    >
                      <h6 className={`pt-2 mb-2 px-3 ellipsis_2_effect ${props.type === 'group' ? `m-0` : `mx-0 my-auto`} `} style={{ WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `15px` : `inherit` }}>{groups_data.name}</h6>
                    </OverlayTrigger>
                    :
                    <h6 className={`py-2 px-3 ellipsis_2_effect ${props.type === 'group' ? `m-0` : `mx-0 my-auto`} `} style={{ WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `15px` : `inherit` }}>{groups_data.name}</h6>
                  }
                </div>
                <div style={ props.type === 'group' ? {} : {position: `absolute`, bottom: `0`, width: `100%`} }>
                {groups_data.card_summary && groups_data.card_summary.length > (props.type === 'group' ? 51 : 57) ?
                  <OverlayTrigger
                    placement={props.type === 'group' ? 'left' : 'top'}
                    overlay={
                      <Tooltip className={`${ props.type === 'group' ? `group-tooltip2` : `group-tooltip`}`} id={`group-${groups_data.id}`} >
                        {groups_data.card_summary ? groups_data.card_summary : ""}
                      </Tooltip>
                    }
                  >
                    <p className={`px-3 m-0 bg-transparent ellipsis_2_effect`} style={{WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `13px` : `15px`, lineHeight: `normal`}}>{ groups_data.card_summary ? groups_data.card_summary : ''} </p>
                  </OverlayTrigger>
                  :
                  <p className={`px-3 m-0 bg-transparent ellipsis_2_effect`} style={{WebkitBoxOrient: 'vertical', fontSize: props.type === 'group' ? `13px` : `15px`, lineHeight: `normal`}}>{ groups_data.card_summary ? groups_data.card_summary : ''} </p>
                }
                  <div className={`my-2 mx-3 text-center d-flex`}>
                    {showCardImage(groups_data.members)}
                    <p className={`ml-2 my-0 align-self-center ${groups_data.count === 0 ? `d-none` : ``}`} style={{fontSize: props.type === 'group' ? `13px` : `18px`}}>{groups_data.count ? groups_data.count : ''} {groups_data.count === 1 ? `Member` : `Members`}</p>
                  </div>
                  <Col sm="12" md="12" xs="12" lg="12" className={`text-white text-center ${Styles.group_button} `} style={{ borderRadius: '0 0 15px 15px' }} >
                    <h5 className="bold m-0 p-1" style={{ fontSize: `20px` }} > {groups_data.is_joined === undefined || groups_data.is_joined === false ? 'Join' : 'View'} </h5>
                  </Col>
                </div>
            </div>
          </Link>
        )
      }
    }
  }else if (props.type === 'blogs'){
    if (width <= 980) {
      if (props.sub_type === 'client_search') {
        return (
          <Col xs="12" sm="6" md="6" key={props.type} style={{padding:'10px 7px'}}>
            <Link to={`/blogs/${props.slug}`} className="d-flex align-items-center w-100">
              <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)', minHeight: '100px', maxHeight: '100px'}}>
                <div className="float-left px-2" style={{minWidth: '100px', maxWidth: '100px'}}>
                  <picture>
                    {props.avatar !== null && props.avatar !== undefined && props.avatar !== 'event_bg.png' ?
                      <LazyLoadImage src={props.avatar} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/> :
                      <Image src={'event_bg.png'} imgStyle={{ objectFit: `contain` }} style={{ width: `100%`, borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}} type={`fluid`} />}
                  </picture>
                </div>
                <div className="float-left w-100 pr-2">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {props.author !== undefined && props.author !== '' ? 
                    <div className="float-left w-100">
                      <h3 className="mb-0 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{`By ${props.author}`}</h3>
                    </div> : null}
                </div>
              </Col>
            </Link>
          </Col>
        )
      } else {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left align-items-center p-3 mb-2 ${props.hidden === '' ? 'd-flex' : props.hidden}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}}>
            <Link to={`/blogs/${props.slug}`} className="d-flex align-items-center w-100">
              <Col xs="4" sm="5" md="3" className="float-left px-0">
                <picture>
                  {props.avatar !== 'event_bg.png' ?
                    <LazyLoadImage src={props.avatar} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/> :
                    <Image src={'event_bg.png'} imgStyle={{ objectFit: `fill` }} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}} type={`fluid`} />
                  }
                </picture>
              </Col>
              <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
                <div className="float-left w-100 pr-1">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {props.author !== undefined && props.author !== '' ? 
                    <div className="float-left w-100">
                      <h3 className="mb-0 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{`By ${props.author}`}</h3>
                    </div> : null}
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
              </Col>
            </Link>
          </Col>
        )
      }
    } else {
      return(
        <a className={`text-black`} href={`/blogs/${props.slug}`} target="_blank" rel="noopener noreferrer">
          <div className={`float-left mr-4 my-3 pointer ${props.hidden === undefined ? '' : props.hidden}`}>
            <div className={`float-left`} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px', maxHeight: '230px', minHeight: '230px', position: 'relative', maxWidth: '240px', minWidth: '240px'}}>
              <div>
                <div style={{ position: `relative`, borderBottom: `1px solid #ebebeb` }}>
                  {props.avatar !== 'event_bg.png' ?
                    <div>
                      <LazyLoadImage src={props.avatar} alt={`${props.title.toLowerCase().split(' ').join('-')}`} effect="blur" height={'140px'} width={'100%'} style={{ margin: '0px', objectFit: `fill`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px` }}/>
                    </div>
                    :
                    <div>
                      <Image src={'event_bg.png'} imgStyle={{ objectFit: `fill` }} style={{ width: `100%`, height: `140px`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px`, backgroundColor: `#4444B7` }} type={`fluid`} />
                    </div>
                  }
                </div>
                <div className={`my-2 px-2`}>
                {props.title && props.title.length > 50 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="blog-tooltip" id={`blog-${props.id}`} >
                        {props.title ? props.title : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect bold mx-0`} style={{fontSize: `15px`}}>{props.title ? props.title : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect bold mx-0`} style={{fontSize: `15px`}}>{props.title ? props.title : ""}</h6>
                }
                {props.author !== undefined && props.author !== '' ? 
                  <h6 className="font-weight-normal" style={{fontSize: 'small', position: 'absolute', bottom: '0.5rem'}}>{props.author}</h6> : null
                }
                </div>
              </div>
            </div>
          </div>
        </a>
      )
    }
  }else if (props.type === 'my-training') {
    let end_date, day, month, year
    if (props.end_date) {
      day = utcDateTime.utcDateTime(props.end_date, 'date')
      month = utcDateTime.utcDateTime(props.end_date, 'month_name')
      year = utcDateTime.utcDateTime(props.end_date, 'year')
    }
    let hash_id =  CryptoJS.AES.encrypt(props.payment_id.toString(), process.env.GATSBY_HASH_KEY)
    if (width < 980) {
      return(
        <Col xs="12" sm="6" md="6" lg="3" className='' style={{padding:'10px 7px'}}>
          <OpenApp
            href="https://leanpitch.com"
            android={`https://eskola.io/CourseDetail?payment_id=${props.payment_id}&&course_name=${props.name}&&prev_page=Dashboard&&user=${props.user} `}
            ios={`leanpitch://leanpitch.com/CourseDetail?payment_id=${props.payment_id}&&course_name=${props.name}&&prev_page=Dashboard&&user=${props.user} `}
          >
            <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
              <div style={{width:'15%',minWidth:'60px'}} >
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                  style={{ margin: '0px', objectFit: `contain`}}
                />
              </div>
              <div style={{width:'80%'}}  className={`pl-2`} >
                <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                {props.data_type === "past" ?
                  <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >{`Completed on ${day} ${month} ${year}`}</h6>
                  :
                  <h6 className={`ellipsis_2_effect mx-0`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical', color: '#a1a5a6', fontSize: '13px'}} >{`Ends on ${day} ${month} ${year}`}</h6>
                }
              </div>
              <div style={{width:'5%'}}  className={`pl-2`} >
                <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
              </div>
            </div>
          </OpenApp>
        </Col>
      )
    } else {
      return(
        <div className={`text-white mr-4 mb-3`} style={{ width: `200px`, maxWidth: `200px`, minWidth: `200px`, borderRadius: '15px', backgroundColor: props.data_type === "past" ? '#6c6c6c' : color_array[(props.index)%(color_array.length)] }}>
          <div className={`px-2 pt-2 mx-1`} style={{width: `60px`, height: `65px`}}>
            <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
              style={{ margin: '0px', objectFit: `contain`}} />
          </div>
          <div className={`px-2 pt-2`} style={{ height: `42px` }}>
            {props.name && props.name.length > 40 ?
                <OverlayTrigger
                  placement={'top'}
                  overlay={
                    <Tooltip className="training-tooltip" id={`training-${props.id}`} >
                      {props.name ? props.name : ""}
                    </Tooltip>
                  }
                >
                  <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
                </OverlayTrigger>
                :
                <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
              }
          </div>
          {props.data_type === "past" ?
          <div className={`px-3 py-2 d-flex`}>
            <div className={`d-inline-flex my-auto`}><span className={`calendar_icon my-auto mr-1`} style={{ backgroundPosition: `336px 0px`, width: `22px`, height: `21px` }}></span></div><h6 className={`ml-2 my-0`} style={{ fontSize: `13px` }} >Completed on <br />{`${day} ${month} ${year}`}</h6>
          </div>
          :
          <div className={`px-3 py-2 d-flex`}>
            <div className={`d-inline-flex my-auto`}><span className={`calendar_icon my-auto mr-1`} style={{ backgroundPosition: `336px 0px`, width: `22px`, height: `21px` }}></span></div><h6 className={`ml-2 my-0`} style={{ fontSize: `13px` }} >Ends on <br />{`${day} ${month} ${year}`}</h6>
          </div>
          }
          <div className={`py-2 text-center font-weight-bold`} style={{ borderTop: `1px solid white`, fontSize: '13px' }}>
            <Link to={"/my-trainings/training/" + (hash_id.toString().replace(/\//g, "-"))} className={`text-white`}>
              <div>
                View Details
                <div className={`${Styles.arrow_right} ml-1`}></div>
              </div>
            </Link>
          </div>
        </div>
      )
    }
  }else if (props.type === 'prime-crash-course') {
    let end_date, day, month, year
    if (props.end_date) {
      day = utcDateTime.utcDateTime(props.end_date, 'date')
      month = utcDateTime.utcDateTime(props.end_date, 'month_name')
      year = utcDateTime.utcDateTime(props.end_date, 'year')
    }
    return(
      <div className={`text-white mr-3 mb-3`} style={{ width: `200px`, maxWidth: `200px`, minWidth: `200px`, borderRadius: '15px', backgroundColor: props.data_type === "past" ? '#6c6c6c' : color_array[(props.index)%(color_array.length)] }}>
        <div className={`px-2 pt-2 mx-1`} style={{width: `60px`, height: `65px`}}>
          <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
            style={{ margin: '0px', objectFit: `contain`}} />
        </div>
        <div className={`px-2 pt-2`} style={{ height: `42px` }}>
          {props.name && props.name.length > 40 ?
              <OverlayTrigger
                placement={'top'}
                overlay={
                  <Tooltip className="training-tooltip" id={`training-${props.id}`} >
                    {props.name ? props.name : ""}
                  </Tooltip>
                }
              >
                <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
              </OverlayTrigger>
              :
              <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
            }
        </div>
        {props.data_type === "past" ?
        <div className={`px-3 py-2 d-flex`}>
          <div className={`d-inline-flex my-auto`}><span className={`calendar_icon my-auto mr-1`} style={{ backgroundPosition: `336px 0px`, width: `22px`, height: `21px` }}></span></div><h6 className={`ml-2 my-0`} style={{ fontSize: `13px` }} >Completed on <br />{`${day} ${month} ${year}`}</h6>
        </div>
        :
        <div className={`px-3 py-2 d-flex`}>
          <div className={`d-inline-flex my-auto`}><span className={`calendar_icon my-auto mr-1`} style={{ backgroundPosition: `336px 0px`, width: `22px`, height: `21px` }}></span></div><h6 className={`ml-2 my-0`} style={{ fontSize: `13px` }} >Ends on <br />{`${day} ${month} ${year}`}</h6>
        </div>
        }
        <div className={`py-2 text-center font-weight-bold`} style={{ borderTop: `1px solid white`, fontSize: '13px' }}>
          <Link to={"/prime-content/crash-course/" + props.id} className={`text-white`}>
            <div>
              View Details
              <div className={`${Styles.arrow_right} ml-1`}></div>
            </div>
          </Link>
        </div>
      </div>
    )
  }else if (props.type === "my-elearning") {
    let hash_id =  CryptoJS.AES.encrypt(props.id.toString(), process.env.GATSBY_HASH_KEY)
    if (props.name === 'Agile Essentials' || props.name === 'Scrum Essentials') {
      return null
    }else{
      if (width < 980) {
        return(
          <Col xs="12" sm="6" md="6" lg="3" className='' style={{padding:'10px 7px'}}>
            <OpenApp
              href="https://leanpitch.com"
              android={`https://eskola.io/ElearnDetail?course_id=${props.id}&&course=${props.name}&&prev_page=Dashboard&&user=${props.user} `}
              ios={`leanpitch://leanpitch.com/ElearnDetail?course_id=${props.id}&&course=${props.name}&&prev_page=Dashboard&&user=${props.user} `}
            >
              <div className={`text-white d-flex`} style={{padding: `11px`, alignItems:'center', border: '1px solid rgb(211, 234, 244)', borderRadius: '15px', height:'100%'}}>
                <div style={{width:'15%',minWidth:'60px'}} >
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                    style={{ margin: '0px', objectFit: `contain`}} />
                </div>
                <div style={{width:'75%'}}  className={`pl-2`} >
                  <h6 className={`ellipsis_2_effect text-black mx-0 my-auto`} style={{ margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.name ? props.name : ""}</h6>
                </div>
                <div style={{width:'10%'}}  className={`pl-2`} >
                  <FontAwesomeIcon icon={faChevronRight} style={{fontSize: `16px`, margin: `auto`, color: `#1e8cbc`}} />
                </div>
              </div>
            </OpenApp>
          </Col>
        )
      } else {
        return(
          <div className={`text-black mr-4 mb-3`} style={{ width: `250px`, maxWidth: `250px`, minWidth: `250px`, borderRadius: '15px', boxShadow: `rgb(216, 214, 214) 0px 0px 9px 2px` }}>
            <div className={`py-2 pl-3 d-flex`}>
              <div className={`d-inline-flex`} style={{width: `80px`, height: `80px`}}>
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'80px'} width={'80px'}
                  style={{ margin: '0px', objectFit: `contain`}} />
              </div>
              <h6 className={`font-weight-bold mx-0 my-auto pl-2`} style={{fontSize: `16px`, color: `#5e5958`}} >{props.name ? props.name : ""}</h6>
            </div>
            <div className={`py-2 text-center font-weight-bold`} style={{ borderTop: `1px solid #5e5958`, fontSize: '13px', color: `#5e5958` }}>
              <Link to={"/my-trainings/elearning/"+ (hash_id.toString().replace(/\//g, "-"))} className={`${Styles.black_link}`}>
                <div>
                  View Details
                  <div className={`${Styles.arrow_right} ml-1`} style={{ backgroundPosition: `0px 165px` }}></div>
                </div>
              </Link>
            </div>
          </div>
        )
      }
    }
  }else if (props.type === 'my-related-courses') {
    let hash_id =  CryptoJS.AES.encrypt(props.course.id.toString(), process.env.GATSBY_HASH_KEY)
    let slug = ''
    if (props.course.e_learning === true) {
      slug =  "/my-trainings/elearning/"+ (hash_id.toString().replace(/\//g, "-"))
    }
    if (props.course.online === true && props.course.e_learning === false) {
      if (props.course.special_class === false) {
        slug = "/prime-content/crash-course/" + props.course.trainings.id
      }
    }
    return(
      <div className={`text-white mr-3 mb-3`} style={{ width: `200px`, maxWidth: `200px`, minWidth: `200px`, borderRadius: '15px', backgroundColor: props.data_type === "past" ? '#6c6c6c' : color_array[(props.index)%(color_array.length)] }}>
        <div className={`px-2 pt-2 mx-1`} style={{width: `60px`, height: `65px`}}>
          <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
            style={{ margin: '0px', objectFit: `contain`}} />
        </div>
        <div className={`px-2 pt-2`} style={{ height: `50px` }}>
          {props.name && props.name.length > 40 ?
              <OverlayTrigger
                placement={'top'}
                overlay={
                  <Tooltip className="training-tooltip" id={`training-${props.id}`} >
                    {props.name ? props.name : ""}
                  </Tooltip>
                }
              >
                <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
              </OverlayTrigger>
              :
              <h6 className={`ellipsis_2_effect font-weight-bold mx-0 my-auto`} style={{fontSize: `16px`}} >{props.name ? props.name : ""}</h6>
            }
        </div>
        <div className={`py-2 text-center font-weight-bold`} style={{ borderTop: `1px solid white`, fontSize: '13px' }}>
          <Link to={`${slug}`} className={`text-white`}>
            <div>
              View Details
              <div className={`${Styles.arrow_right} ml-1`}></div>
            </div>
          </Link>
        </div>
      </div>
    )
  }else if (props.type === "text_testimonial") {
    let reviewer_name = ''
    if (props.name) {
      if (props.name.length > 15) {
        reviewer_name = props.name.split(' ')[0]
      } else {
        reviewer_name = props.name
      }
    }
    if (width <= 980) {
      return(
        <Col sm="6" md="6" xs="12" className={`float-left mt-3`} style={{color: 'rgb(59, 59, 59)', maxWidth: '275px'}}>
          <Col sm="12" md="12" xs="12" className={`float-left p-2`} style={{borderRadius: '5px', border: '1px solid rgb(188, 233, 253)'}}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center">
              <Col sm="3" md="3" xs="3" className={`float-left px-2`} style={{maxWidth: '100px', minWidth: '100px'}}>
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '80px', borderRadius: '50%'}}/>
              </Col>
              <Col sm="9" md="9" xs="9" className={`float-left px-1`}>
                <h5 className={`font-weight-bold`} style={{fontSize: '14px'}}>{reviewer_name}</h5>
              </Col>
            </Col>
            <Col xs="12" sm="12" md="12" className="float-left px-0 mt-2" style={{minHeight: '125px', maxHeight: '125px', overflowY: 'auto'}}>
              <h5 className="mb-0" style={{fontSize: '12px'}}>{props.review}</h5>
            </Col>
          </Col>
        </Col>
      )
    } else {
      return(
        <Col sm="4" md="4" lg="4" className={`float-left text-black mt-3 mb-3 ${props.hidden}`}>
          <fieldset className="px-2" style={{borderRadius: '15px', border: '1px solid rgb(192, 192, 192)'}}>
            <legend style={{width: '95px'}}>
              <Image src="quote.png" imgStyle={{objectFit: `contain`}} style={{width: `95px`, height: `95px`, position: 'relative'}} type={`fluid`}/>
            </legend>
            <Col sm="12" md="12" lg="12" className={`float-left mt-3 px-0`} style={{minHeight: '170px', maxHeight: '170px'}}>
              <div className={`py-2 d-flex`} style={{marginTop: '-2.25rem'}}>
                <Col sm="3" md="3" lg="3" className={`float-left px-0`}>
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '80px', borderRadius: '50%'}}/>
                </Col>
                <Col sm="9" md="9" lg="9" className={`float-left px-1`}>
                  <h5 className={`font-weight-bold`} style={{fontSize: '1.5vw'}}>{reviewer_name}</h5>
                  <h6 className={`font-weight-normal`} style={{fontSize: '1vw', maxHeight: '150px', overflowY: 'scroll'}}>{props.review}</h6>
                </Col>
              </div>
            </Col>
          </fieldset>
        </Col>
      )
    }
  }else if (props.type === "text_testimonial_page") {
    let reviewer_name = ''
    if (props.name) {
      if (props.name.length > 15) {
        reviewer_name = props.name.split(' ')[0]
      } else {
        reviewer_name = props.name
      }
    }
    if (width <= 980) {
      return(
        <Col sm="6" md="6" xs="12" className={`float-left mt-3 ${props.hidden}`} style={{color: 'rgb(59, 59, 59)'}}>
          <Col sm="12" md="12" xs="12" className={`float-left p-2`} style={{borderRadius: '5px', border: '1px solid rgb(188, 233, 253)'}}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center">
              <Col sm="3" md="3" xs="3" className={`float-left px-2`} style={{maxWidth: '100px', minWidth: '100px'}}>
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '80px', borderRadius: '50%'}}/>
              </Col>
              <Col sm="9" md="9" xs="9" className={`float-left px-1`}>
                <h5 className={`font-weight-bold`} style={{fontSize: '14px'}}>{reviewer_name}</h5>
              </Col>
            </Col>
            <Col xs="12" sm="12" md="12" className="float-left px-0 mt-2">
              <h5 className="mb-0" style={{fontSize: '12px'}}>{props.review}</h5>
            </Col>
          </Col>
        </Col>
      )
    } else {
      return(
        <Col sm="12" md="12" lg="12" className={`float-left text-black mt-3 mb-5 ${props.hidden}`}>
          <fieldset className="px-2" style={{borderRadius: '15px', border: '1px solid rgb(192, 192, 192)'}}>
            <legend style={{width: '110px'}}>
              <Image src="quote.png" imgStyle={{objectFit: `contain`}} style={{width: `110px`, height: `110px`, position: 'relative'}} type={`fluid`}/>
            </legend>
            <Col sm="12" md="12" lg="12" className={`float-left px-0`}>
              <div className={`py-2 d-flex`} style={{marginTop: '-1.5rem'}}>
                <Col sm="3" md="3" lg="3" className={`float-left px-0`}>
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '80px', borderRadius: '50%'}}/>
                </Col>
                <Col sm="9" md="9" lg="9" className={`float-left px-1`}>
                  <h5 className={`font-weight-bold`} style={{fontSize: '1.5vw'}}>{reviewer_name}</h5>
                  <h6 className={`font-weight-normal`} style={{fontSize: '1vw'}}>{props.review}</h6>
                </Col>
              </div>
            </Col>
          </fieldset>
        </Col>
      )
    }
  }else if (props.type === "success_story_page") {
    if (width <= 980) {
      return(
        <Col sm="6" md="6" xs="12" className={`float-left ${props.hidden}`} style={{padding:'10px 7px'}}>
          <a href={props.url} target="_blank" rel="noreferrer noopener">
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)'}}>
              <div className="float-left px-2" style={{minWidth: '100px', maxWidth: '100px'}}>
                <picture>
                  <LazyLoadImage src={props.avatar} alt={`${props.name.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '50%'}}/>
                </picture>
              </div>
              <div className="float-left pr-2 d-flex align-items-center w-100">
                <div className="float-left w-100">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.name}</h3>
                  <h3 className="mb-0 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{props.mini_detail}</h3>
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(49, 159, 203)'}}/>
              </div>
            </Col>
          </a>
        </Col>
      )
    } else {
      return(
        <Col sm="12" md="12" lg="12" className={`float-left text-black mt-3 mb-5 ${props.hidden}`}>
          <fieldset className="px-2" style={{borderRadius: '15px', border: '1px solid rgb(192, 192, 192)'}}>
            <legend style={{width: '110px'}}>
              <Image src="quote.png" imgStyle={{objectFit: `contain`}} style={{width: `110px`, height: `110px`, position: 'relative'}} type={`fluid`}/>
            </legend>
            <Col sm="12" md="12" lg="12" className={`float-left px-0`}>
              <div className={`py-2 d-flex`} style={{marginTop: '-1.5rem'}}>
                <Col sm="3" md="3" lg="3" className={`float-left px-0`}>
                  <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '100px', borderRadius: '50%'}}/>
                </Col>
                <Col sm="9" md="9" lg="9" className={`float-left`}>
                  <h5 className={`font-weight-bold mb-1`} style={{fontSize: '1.5vw'}}>{props.name}</h5>
                  <h6 className={`font-weight-normal mb-1`} style={{fontSize: '1vw'}}>{props.company_and_designation}</h6>
                  <h6 className={`font-weight-normal mb-1`} style={{fontSize: '1vw'}}>{props.mini_detail}</h6>
                  <Col sm="12" md="12" lg="12" className={`float-left mb-3`}>
                    <div className="float-left offset-1">
                      <a className={`align-items-center mt-3 bg-white text-black d-flex ${Styles.success_story_hover}`} href={props.url} target="_blank" style={{borderRadius: '25px', border: '1px solid rgb(43, 49, 43)', fontSize: '1vw', padding: '1px 10px'}} rel="noreferrer noopener">View Success Story<span className="down-arrow-black rotate-right" /></a>
                    </div>
                  </Col>
                </Col>
              </div>
            </Col>
          </fieldset>
        </Col>
      )
    }
  }else if (props.type === "success_story") {
    return(
      <Col sm="4" md="4" lg="4" className={`float-left text-black mt-3 mb-5 ${props.hidden}`}>
        <fieldset className="px-2" style={{borderRadius: '15px', border: '1px solid rgb(192, 192, 192)'}}>
          <legend style={{width: '110px'}}>
            <Image src="quote.png" imgStyle={{objectFit: `contain`}} style={{width: `110px`, height: `110px`, position: 'relative'}} type={`fluid`}/>
          </legend>
          <Col sm="12" md="12" lg="12" className={`float-left px-0`}>
            <div className={`py-2 d-flex`} style={{marginTop: '-1.5rem'}}>
              <Col sm="3" md="3" lg="3" className={`float-left px-0`}>
                <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" style={{objectFit: `contain`, width: '100px', borderRadius: '50%'}}/>
              </Col>
              <Col sm="9" md="9" lg="9" className={`float-left pr-0`} style={{maxHeight: '160px', minHeight: '160px', position: 'relative'}}>
                <h5 className={`font-weight-bold mb-1`} style={{fontSize: '1.5vw'}}>{props.name}</h5>
                <h6 className={`font-weight-normal mb-1`} style={{fontSize: '1vw'}}>{props.company_and_designation}</h6>
                <h6 className={`font-weight-normal mb-1`} style={{fontSize: '1vw'}}>{props.mini_detail}</h6>
                <Col sm="12" md="12" lg="12" className={`float-left mb-3`} style={{position: 'absolute', bottom: '0'}}>
                  <a className={`align-items-center mt-2 float-left bg-white text-black d-flex ${Styles.success_story_hover}`} href={props.url} target="_blank" style={{borderRadius: '25px', border: '1px solid rgb(43, 49, 43)', fontSize: '1vw', padding: '1px 10px'}} rel="noreferrer noopener">View Success Story<span className="down-arrow-black rotate-right" /></a>
                </Col>
              </Col>
            </div>
          </Col>
        </fieldset>
      </Col>
    )
  }else if (props.type === 'blog_training') {
    if (width <= 980) {
      return(
        <Col xs="12" sm="6" md="6" key={props.index.toString()+props.type} style={{padding:'10px 7px'}}>
          <Link className={`no_text_decoration`} to={`/${props.slug}`}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)', minHeight: '100px', maxHeight: '100px'}}>
              <div className="float-left px-2" style={{minWidth: '80px', maxWidth: '80px'}}>
                <picture>
                  <LazyLoadImage src={props.avatar} alt={`${props.long_title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px'}}/>
                </picture>
              </div>
              <div className="float-left w-100 pr-2">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.long_title}</h3>
                <h3 className="mb-1 font-weight-bold w-100 ellipsis_2_effect" style={{color: 'rgb(101, 102, 103)', fontSize: '12px'}}>{`Next Batch : ${props.training_start_date === undefined ? 'Loading...' : props.training_start_date}`}</h3>
              </div>
            </Col>
          </Link>
        </Col>
      )
    } else {
      return(
        <Col key={props.index.toString()+props.type} className={`float-left ${Styles.width_240}`} style={{marginLeft: '5px',paddingLeft: '0px'}}>
          <Link className={`no_text_decoration`} to={`/${props.slug}`}>
            <div className={`${Styles.card1} text-white`} style={{ color: `white`, borderRadius: '25px',backgroundColor: color_array[(props.index)%(color_array.length)] }}>
              <div style={{padding: `12px`,height: `131px`}}>
                <div style={{width: `60px`, height: `60px`}} >
                    <LazyLoadImage src={props.avatar} alt={props.name} effect="blur" height={'60px'} width={'60px'}
                      style={{ margin: '0px', objectFit: `contain`}}
                    />
                </div>
                {props.long_title && props.long_title.length > 40 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`classroom-${props.long_title}`} >
                        {props.long_title ? props.long_title : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.long_title ? props.long_title : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect mx-0 my-auto`} style={{ paddingTop: `5px`, margin: `0px`,fontWeight: 'bold', WebkitBoxOrient: 'vertical'}} >{props.long_title ? props.long_title : ""}</h6>
                }
              </div>
              <div className="text-white" style={{backgroundColor: strip_color_array[(props.index)%(color_array.length)] }}>
                <h6 className="" style={{ paddingTop: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: '300',color: 'white',fontSize: '12px'}}>Upcoming Training</h6>
                <h6 style={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `12px`, margin: `0px`,fontWeight: 'bold',fontSize: '16px'}}>{props.training_start_date === undefined ? <div style={{ fontSize: '16px' }}><Spinner animation="border" size="sm" className={`mr-1`} />  Loading...</div> : props.training_start_date}</h6>
              </div>
              <h5 className={`${Styles.card_button}`}>Register</h5>
            </div>
          </Link>
        </Col>
      )
    }
  }else if(props.type === 'city_event' && props.event_data){
    let event_data = props.event_data
    let day,month,year,event_date
    let event_type = ["Webinar","Meetup","Conference"]
    let event_bg = ['#4444B7', '#722970', '#236361', '#8C2525']

    event_date = event_data.start_date ? `${utcDateTime.utcDateTime(event_data.start_date, 'date')} ${utcDateTime.utcDateTime(event_data.start_date, 'month_name')}, ${utcDateTime.utcDateTime(event_data.start_date, 'year')}` : 'will be scheduled soon'
    let portrait_screen = window.screen.orientation.type === 'portrait-primary' ? true : false
    let mobile_div_t = (
      <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)'}}>
        <Col xs="5" sm="5" md="5" className="float-left px-2">
          {event_data.background_avatar === undefined || event_data.background_avatar === null ?
            <Image src={'event_bg.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `100%`, borderRadius: `5px`, backgroundColor: event_bg[event_data.event_type] }} type={`fluid`} />
            :
            <LazyLoadImage src={event_data.background_avatar} alt={event_data.title} effect="blur" width={'100%'} style={{ objectFit: `cover`, borderRadius: `5px`}}
            />
          }
          <h6 className={`mr-3 pb-1 px-2 font-weight-bold d-flex`} style={{ marginTop: `10px`, paddingTop: '0.2rem', fontSize: '10px', position: `absolute`, top: `0`, right: `-5px`, backgroundColor: `#f5f6f8`, borderRadius: `15px`, boxShadow: 'rgb(216, 214, 214) 0px 0px 4px 0px' }}>{event_type[event_data.event_type]}
          </h6>
          <h3 className={`font-weight-bold my-0 mx-auto text-center text-white font-16 ${Styles.drop_shadow_icon} ${event_data.background_avatar === undefined || event_data.background_avatar === null ? '' : 'd-none'} `} style={{ position: `absolute`, inset: portrait_screen ? '65px 0' : '55px 0', fontFamily: `sans-serif` }}>
            {event_type[event_data.event_type]}
          </h3>
          <div className={`${event_data.license_type !== 'Basic' ? '' : 'd-none'}`} style={{ position: `absolute`, top: `0`, left: `8px`}}>
            <Image src={event_data.license_type.toLowerCase()+'_pricing.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `60px`, height: `60px`, zIndex: 1 }} type={`fluid`} />
          </div>
        </Col>
        <Col xs="7" sm="7" md="7" className="float-left px-2 d-flex align-items-center">
          <div className="float-left w-100">
            <h6 className={`ellipsis_2_effect bold mx-0 my-auto font-14`} style={{color: 'rgb(59, 59, 59)'}} >{event_data.title ? event_data.title : ""}</h6>
            <p className={`mb-1 d-flex`} style={{ fontSize: `small`, color: `rgb(101, 102, 103)` }} ><span className={`calendar_icon my-auto mr-1`}></span> : {event_date}</p>
            <p className={`m-0 d-flex`} style={{ fontSize: `small`, color: `rgb(101, 102, 103)` }} ><span className={`${event_data.city ? 'venue_icon' : 'webinar_icon' } my-auto mr-1`}></span> : {event_data.city ? event_data.city : 'Online'}</p>
          </div>
          <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(49, 159, 203)'}}/>
        </Col>
      </Col>
    )
    if ((event_data.event_type === '3' && event_data.slug.indexOf("conference_slug") > -1) || event_data.slug.indexOf("open_by_slug") > -1) {
      return(
        <Row className="mx-auto w-100">
          <Col md="6" sm="6" xs="12" className={`float-left mb-2`} >
            <a className={`w-100`} href={event_data.webinar_link} target="_blank" rel="noopener noreferrer">
              {mobile_div_t}
            </a>
          </Col>
        </Row>
      )
    }else {
      return(
        <Row className="mx-auto w-100">
          <Col md="6" sm="6" xs="12" className={`float-left mb-2`} >
            <Link className={`w-100`} to={`/events/${event_data.slug}`}>
              {mobile_div_t}
            </Link>
          </Col>
        </Row>
      )
    }
  }else{
    return null
  } 
}

export default Card